import { IconPropsType } from '..';

export const CompletedIcon = ({ ...props }: IconPropsType) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M12.4217 3.684L7.27181 8.83384L4.30172 5.86374L3.42318 6.74229L7.27181 10.5909L13.3002 4.56368L12.4217 3.684Z" />
    <path d="M9.752 3.2666L6.3867 6.6319L7.26549 7.51068L10.6308 4.14539L9.752 3.2666Z" />
    <path d="M1.57898 6.21881L0.700195 7.09759L4.19346 10.5909L5.07225 9.71208L1.57898 6.21881Z" />
  </svg>
);
